// eslint-disable-next-line import/prefer-default-export
export const HISTORY_SET = 'HISTORY_SET';
